import { Component, Vue, Inject } from 'vue-property-decorator';
import sissconst from './sissconst';

export default class AppBase extends Vue {

}
